import { Component, ElementRef, output, signal, viewChild, WritableSignal } from '@angular/core';
import { ImageFile } from 'src/app/common/dropbox/image-uploader/image-uploader.directive';
import { ButtonComponent } from "src/app/common/button/button.component";
import { CameraComponent } from "src/app/common/camera/camera.component";
import { DropboxComponent } from "src/app/common/dropbox/dropbox.component";
import { DialogBackdropDirective } from "src/app/common/directives/dialog-backdrop/dialog-backdrop.directive";
import { HeaderComponent } from "src/app/common/dialog-component/header/header.component";
@Component({
  selector: 'profile-image-upload',
  imports: [
    CameraComponent,
    ButtonComponent,
    DropboxComponent,
    DialogBackdropDirective,
    HeaderComponent
],
  templateUrl: './profile-image-upload.component.html',
  styleUrl: './profile-image-upload.component.scss'
})
export class ProfileImageUploadComponent {
  // refs
  modal = viewChild<ElementRef>('modal');

  // ouputs
  onSubmit = output<File>();

  // data
  cameraFile: WritableSignal<File|null> = signal(null);
  showCamera: boolean = false;
  dropboxFile: WritableSignal<ImageFile[] | null> = signal(null);

  submit() {
    if(!this.cameraFile() && !this.dropboxFile()) return;

    this.onSubmit.emit(this.cameraFile() ?? this.dropboxFile()![0].file);
    this.onDismiss();
  }

  onDismiss(){
    this.modal()!.nativeElement.close();
    this.cameraFile.set(null);
    this.dropboxFile.set(null);
    this.showCamera = false;
  }
  onShow(){
    this.modal()!.nativeElement.show();
  }

}
